<template>
    <div class="oasispay-website">
        <!--loading-->
        <div class="loading" v-show="$pageLoadedIcon">
            <div class="loading-wrap"></div>
            <div class="loading-animate"></div>
        </div>
        <!--loading end-->
        <!--head-->
        <div class="oasispay-head" v-show="$appConfig.PARAMS.head === 'Y' && $pageLoadedDone">
            <div class="oasispay-head-warper">
                <div class="oasispay-head-l"><a href="javascript:void(0);"></a><span v-html="$t('web_title')"></span>
                </div>
                <div class="oasispay-head-r"><span>UID: </span><strong v-html="$appConfig.PARAMS.user_id"></strong>
                </div>
                <div class="clear"></div>
            </div>

        </div>
        <!--head end-->
        <!--body-->
        <div class="oasispay-body-warper">
            <div id="oasispay-payment-box" v-show="$pageLoadedDone">
                <div class="oasispay-body-top"></div>
                <div class="oasispay-body">
                    <div class="oasispay-server">
                        <Servers></Servers>
                    </div>
                    <div class="oasispay-region" v-if="!$noChannelData">
                        <Countrys></Countrys>
                    </div>
                    <div class="oasispay-package">
                        <PackageBoxs></PackageBoxs>
                    </div>
                    <div class="oasispay-safe">
                        <span><img src="~assets/safe_2.jpg"></span>
                        <span><img src="~assets/safe_1.jpg"></span>
                    </div>
                </div>
                <div class="oasispay-body-bottom"></div>
            </div>
        </div>
        <!--body end-->
        <!--footer-->
        <div class="oasispay-footer" v-show="$appConfig.PARAMS.head === 'Y' && $pageLoadedDone">
            <iframe class="oaspay_footer" scrolling="no" frameborder="0" allowtransparency="true"
                    :src="$footerUrl"></iframe>
        </div>
        <!--footer end-->
        <!--pop-->
        <div :class="`oasis-payment-pop ${$appConfig.PARAMS.lang==='ar-AE' ? 'oasis-ar': 'oasis-other'}`" :style="setOasispayPop()" v-show="$popStatus.show">
            <div class="oasis-payment-pop-warp" v-if="!$popStatus.isIframe">
                <div class="oasis-payment-pop-title">{{$popStatus.title}}<i @click="$POP_HIDE_HANDLE()"
                                                                            class="oasis-payment-pop-close"></i></div>
                <div class="oasis-payment-pop-desc" v-html="$popStatus.desc"></div>
                <div class="oasis-payment-pop-btn">
                    <a class="oasis-payment-pop-ok" @click="$POP_CONFIRM_HANDLE()" v-show="$popStatus.btn.yes"
                       href="javascript:void(0);"><span>{{$t('pop_yes')}}</span></a>
                    <a class="oasis-payment-pop-no" @click="$POP_HIDE_HANDLE()" v-show="$popStatus.btn.no"
                       href="javascript:void(0);"><span>{{$t('pop_no')}}</span></a>
                </div>
            </div>
            <div class="oasis-payment-pop-warp-iframe"
                 :style="`height:${$popStatus.iframeWH.height-2}px;width:${$popStatus.iframeWH.width-2}`"
                 v-if="$popStatus.isIframe">
                <div class="oasis-payment-pop-title">{{$popStatus.title}}<i @click="$POP_HIDE_HANDLE()"class="oasis-payment-pop-close"></i></div>
                <div class="iloading" :style="`height:${$popStatus.iframeWH.height-32}px`">
                    <div class="iloading-wrap"></div>
                    <div class="iloading-animate"></div>
                </div>
                <iframe :src="$popStatus.iframeUrl" frameborder="0" :height="$popStatus.iframeWH.height-32"
                        :width="$popStatus.iframeWH.width-2"></iframe>
            </div>
        </div>
        <!--pop end-->
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import Servers from "./servers/Index";
    import Countrys from "./country/Index";
    import PackageBoxs from "./packagebox/Index";
    import $ from "jquery";


    export default {
        name: 'app',
        components: {
            Servers,
            PackageBoxs,
            Countrys
        },
        data() {
            return {
                loadIframeDone: false
            }
        },
        computed: {
            ...mapState(['$appConfig', '$common', '$pageLoadedDone', '$pageLoadedIcon', '$popStatus', '$lang', '$footerUrl','$noChannelData', '$lodash']),
            ...mapState('Module_Access', ['userAccessStatus']),
        },
        created() {
            //设置title
            document.title = this.$t('web_title');

            let me = this;

            //绑定页面回车事件
            $(window).keydown(function (event) {
                if (event.keyCode === 13 && me.$popStatus.show) {
                    me.$POP_CONFIRM_HANDLE();
                } else {
                    console.log(event.keyCode);
                }
            });

            //判断服务器id，用户id，游戏code不能为空
            if (!this.$appConfig.PARAMS.user_id || !this.$appConfig.PARAMS.merchant_shop_code) {
                console.log(this.$appConfig.PARAMS);
                this.$POP_SHOW_HANDLE({
                    show: true,
                    title: this.$lang.tips_text,
                    desc: this.$lang['params_not_empty'],
                    callback($state, popDeflaut) {
                        $state.$popStatus = popDeflaut;
                    }
                });
                return;
            }


            /**
             * 检查用户是否登陆
             */
            me.checkUserLogin(me.$appConfig)
            .then((res) => {
                /**
                 * 用户传入UID与登陆UID一致
                 */
                if (res['user_id'] === me.$appConfig.PARAMS.user_id) {
                    //加载主体样式表
                    me.$LOAD_STYLE_HANDE();

                    //加载风控系统
                    me.ACCESS_INIT();

                } else {
                    let reg = /uid=([^&]*)/;
                    window.location.href = window.location.href.replace(reg, `uid=${res['user_id']}`);
                }
            })
            .catch((res) => {
                /**
                 * 未登陆
                 */
                if (res.type === 'nologin') {
                    let login_url = '';
                    let actUrl = encodeURIComponent(window.location.href);
                    let params = `lang=${me.$common.getLang5to2Value(me.$appConfig.PARAMS.lang)}&callback=${actUrl}`;
                    if (res.res['login_url'].indexOf('?') === -1) {
                        login_url = `${res.res['login_url']}?${params}`;
                    } else {
                        login_url = `${res.res['login_url']}&${params}`;
                    }
                    window.location.href = login_url;
                }
                /**
                 * 网络错误或者服务器错误
                 */
                if (res.type === 'error') {
                    console.log(res.res)
                }
            });
        },

        watch: {
            userAccessStatus: function (val) {
                if (val === true) {
                    //加载应用LOGO
                    this.GET_APP_LOGO();
                }
            },
        },

        methods: {
            ...mapActions(['$POP_HIDE_HANDLE', '$POP_SHOW_HANDLE', '$POP_CONFIRM_HANDLE', '$LOAD_STYLE_HANDE']),
            ...mapActions('Module_Access', ['ACCESS_INIT', 'GET_APP_LOGO']),
            ...mapActions('Module_Logo', ['GET_APP_LOGO']),

            setOasispayPop() {
                if (this.$popStatus.isIframe) {
                    let width = this.$popStatus.iframeWH.width;
                    //let height = this.$popStatus.iframeWH.height;
                    return `width: ${width}px;`;
                }
                return '';

            },

            /**
             * 获取当前域名所有cookie
             */
            getAllCookie() {
                let cookies = document.cookie;
                let allCookiesArr = cookies.split('; ');
                let cookieObj = {};
                for (let key in allCookiesArr) {
                    let item = allCookiesArr[key].split('=');
                    cookieObj[item[0]] = decodeURIComponent(item[1]);
                }
                return cookieObj;
            },

            /**
             * 检查用户是否登陆成功
             */
            checkUserLogin(appconfig) {
                let me = this;
                let tpl = appconfig.getVersionInfo();
                let url = tpl.api.app_base_url + tpl.api.app_check;
                let cookies = this.getAllCookie();
                let data = this.$lodash['merge']({}, cookies, {
                    merchant_shop_code: appconfig.PARAMS.merchant_shop_code,
                    user_id: appconfig.PARAMS.user_id,
                    merchant_id: appconfig.PARAMS.merchant_id
                });
                return new Promise((resolve, reject) => {
                    me.$common.ajax({
                        url: url,
                        type: 'post',
                        data: data,
                        success(res) {
                            if (res && res.code === 200) {
                                /**
                                 * 登陆成功
                                 */
                                if (res.result.status === 1) {
                                    resolve(res.result);
                                }

                                /**
                                 * 未登陆
                                 */
                                if (res.result.status === 0) {
                                    reject({type: 'nologin', res: res.result});
                                }
                            }

                        },
                        error(res) {
                            reject({type: 'error', res: res});
                        }
                    })
                })
            },
        }

    };
</script>

<style type="scss">
    /**loading**/
    @-webkit-keyframes ispin {
        0% {
            -webkit-transform: rotate(0deg);
        }

        50% {
            -webkit-transform: rotate(360deg);
        }

        100% {
            -webkit-transform: rotate(0deg);
        }
    }

    @keyframes ispin {
        0% {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(360deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }

    .iloading {
        z-index: 89;
        opacity: 1;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .iloading-wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 88;
        background: #fff;
    }

    .iloading-animate {
        width: 60px;
        height: 60px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -30px 0 0 -30px;
        z-index: 2199;
        border: 4px solid #00a9e1;
        border-left-color: transparent;
        border-right-color: transparent;
        border-radius: 50%;
        animation: ispin 2s infinite;
        -webkit-animation: ispin 2s infinite;
    }

    /**loading***/


    .oasispay-head {
        width: 100%;
        height: 50px;
        background: #3c3c3c;
        color: #d8d8d8;
    }

    .oasispay-head-warper {
        width: 1000px;
        margin: 0 auto;
        height: 100%;
    }

    .oasispay-head-l {
        float: left;
        line-height: 50px;
        height: 100%;
    }

    .oasispay-head-l > * {
        display: inline-block;
        vertical-align: top;
        line-height: 50px;
        height: 100%;
    }

    .oasispay-head-l a {
        background: url("~assets/logo.png") no-repeat center left;
        height: 100%;
        width: 180px;
    }

    .oasispay-head-l span {
        font-size: 18px;
        font-weight: bold;
        height: 20px;
        margin: 15px 0;
        line-height: 20px;
        border-left: 1px solid #d8d8d8;
        padding-left: 10px;
    }

    .oasispay-head-r {
        float: right;
        line-height: 50px;
        height: 100%;
        font-size: 14px;
    }

    .oasispay-head-r strong {
        color: #ee8f43;
    }

    .oasis-safe-box {
        position: absolute;
        display: flex;
        justify-content: space-around;
        align-items: center
    }

    .oasis-safe-list {
        height: 26px;
        width: 110px;
    }

    .oasis-payment-type-tab ul {
        display: flex;
        justify-content: flex-start;
        align-items: center
    }

    .oasis-payment-pop {
        background: #d17a26;
        position: fixed;
        width: 550px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
    }

    .oasis-payment-pop-warp {
        margin: 1px;
        padding-bottom: 45px;
        background: #fff;
    }

    .oasis-payment-pop-warp-iframe {
        margin: 1px;
    }

    .oasis-payment-pop-warp-iframe iframe {
        position: absolute;
        top: 30px;
        left: 0;
        z-index: 100;
    }

    .oasis-payment-pop-title {
        font-weight: bold;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 15px;
        position: relative;
        background: #d17a26;
        text-align: center;
        color: #fff;
    }

    .oasis-payment-pop-close {
        cursor: pointer;
        top: 5px;
        width: 16px;
        height: 16px;
        position: absolute;
        background: url("https://img.oasgames.com/upload/1552358211.png") no-repeat;
    }

    .oasis-ar {
        direction: rtl;
    }
    .oasis-ar .oasis-payment-pop-close {
        left: 5px;
    }

    .oasis-other .oasis-payment-pop-close {
        right: 5px;
    }

    .oasis-payment-pop-btn {
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .oasis-payment-pop-btn > * {
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        border:1px solid #d97537;
        border-radius: 5px;
        min-width: 60px;
        margin: 0 11px;
        text-decoration: none;
        text-align: center;
        color: #fff;
    }

    .oasis-payment-pop-btn span {
        display: inline-block;
        vertical-align: top;
        height: 28px;
        line-height: 28px;
        min-width: 60px;
        padding: 0 20px;
        border-top: 1px solid #fcb254;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#fa900a+0,e57d06+50,d16a02+100 */
        background: #fa900a; /* Old browsers */
        background: -moz-linear-gradient(top, #fa900a 0%, #e57d06 50%, #d16a02 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, #fa900a 0%, #e57d06 50%, #d16a02 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, #fa900a 0%, #e57d06 50%, #d16a02 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fa900a', endColorstr='#d16a02', GradientType=0); /* IE6-9 */
    }

    .oasis-payment-pop-desc {
        font-size: 14px;
        line-height: 20px;
        padding: 16px 30px 32px;
    }

    .closePaymentPageGoToGames {
        background: url('https://img.oasgames.com/upload/1550572164.png') no-repeat;
        width: 18px;
        height: 20px;
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    .closePaymentPageGoToGames a {
        display: inline-block;
        vertical-align: top;
        width: 100%;
        height: 100%;
    }

    /**loading**/
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }

        50% {
            -webkit-transform: rotate(360deg);
        }

        100% {
            -webkit-transform: rotate(0deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(360deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }

    .loading {
        position: relative;
        z-index: 89;
        opacity: 0.5;
    }

    .loading-wrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 88;
        background: #000;
    }

    .loading-animate {
        width: 60px;
        height: 60px;
        position: fixed;
        top: 50%;
        left: 50%;
        margin: -30px 0 0 -30px;
        z-index: 2199;
        border: 4px solid #00a9e1;
        border-left-color: transparent;
        border-right-color: transparent;
        border-radius: 50%;
        animation: spin 2s infinite;
        -webkit-animation: spin 2s infinite;
    }
</style>



// WEBPACK FOOTER //
// website/components/App.vue